import React from 'react';
import { Grid } from '@mui/material';
import Section from '../../../shared/Section/Section';
import Accordions from '../../../shared/Accordions/Accordions';

const PrecourseFAQ = ({ title, questions }) => {
  return (
    <Section title={title} withoutBg>
      <Grid container>
        <Grid item xs={12}>
          {questions.map(({ q, a }) => (
            <Accordions
              sx={{ py: { xs: 0, lg: 1 }, pr: { xs: 0, lg: 1 } }}
              key={q}
              summary={q}
              details={a}
            />
          ))}
        </Grid>
      </Grid>
    </Section>
  );
};

export default PrecourseFAQ;
